module.exports = __webpack_public_path__ + "img/cal.ebe1f1a4.svg";